// extracted by mini-css-extract-plugin
export default {"title":"lkdq0","subtitle":"E9kZw","skeleton":"QNeAf","loading":"Xy1Pa","section":"g_1Mb","containerHeader":"Zgc1L","waysToStyleCarouselContainer":"xqB6o"};